'use client';

import { CurrentRefinements, CurrentRefinementsProps } from 'react-instantsearch';

type AlgoliaCurrentRefinementsProps = CurrentRefinementsProps;

export function AlgoliaCurrentRefinements(props: AlgoliaCurrentRefinementsProps) {
  return (
    <CurrentRefinements
      classNames={{
        label: 'hidden',
        delete: 'hidden',
        noRefinementRoot: 'hidden',
        list: 'flex justify-center md:justify-start flex-wrap gap-xs',
        item: 'text-base font-semibold font-heading px-md py-xs w-fit rounded-full border border-secondary-200 flex items-center',
      }}
      {...props}
    />
  );
}
